"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOnPopupScroll = void 0;
var createOnPopupScroll = function (fn, offset) {
    if (offset === void 0) { offset = 2; }
    return function (e) {
        e.persist();
        var target = e.target;
        if (
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'scrollTop' does not exist on type 'Event... Remove this comment to see the full error message
        target.scrollTop + target.offsetHeight + offset >=
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'scrollTop' does not exist on type 'Event... Remove this comment to see the full error message
            target.scrollHeight) {
            fn === null || fn === void 0 ? void 0 : fn();
        }
    };
};
exports.createOnPopupScroll = createOnPopupScroll;
